import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import AuthShell from "./AuthShell";

function AuthStatusAction({ action, secondary = false }) {
  if (!action?.label) {
    return null;
  }

  const className = secondary
    ? "auth-status__button auth-status__button--secondary"
    : "auth-status__button";

  if (action.to) {
    return (
      <Link to={action.to} className={className}>
        {action.label}
      </Link>
    );
  }

  return (
    <button type="button" className={className} onClick={action.onClick}>
      {action.label}
    </button>
  );
}

function AuthStatusPage({
  pageTitle,
  topBarPrompt,
  topBarCtaLabel,
  topBarCtaTo,
  icon,
  iconAlt,
  eyebrow,
  title,
  description,
  tone = "neutral",
  primaryAction,
  secondaryAction,
  children,
}) {
  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <AuthShell
        topBarPrompt={topBarPrompt}
        topBarCtaLabel={topBarCtaLabel}
        topBarCtaTo={topBarCtaTo}
      >
        <div className="auth-status">
          {icon ? (
            <div className={`auth-status__icon auth-status__icon--${tone}`}>
              <img src={icon} alt={iconAlt} loading="lazy" />
            </div>
          ) : null}

          {eyebrow ? <p className="auth-status__eyebrow">{eyebrow}</p> : null}
          <h1 className="auth-status__title">{title}</h1>
          <p className="auth-status__copy">{description}</p>

          {children ? <div className="auth-status__details">{children}</div> : null}

          <div className="auth-status__actions">
            <AuthStatusAction action={primaryAction} />
            <AuthStatusAction action={secondaryAction} secondary />
          </div>
        </div>
      </AuthShell>
    </>
  );
}

export default AuthStatusPage;
